import _ from 'underscore';
import { withGlobalErrorView } from './with-global-error-view';

const fallbackOnChunkError = ({ name } = {}) => {
  if (name !== 'ChunkLoadError') {
    return;
  }
  const fallbackParam = 'fallbackSource';
  const currentUrl = new URL(window.location.href);
  const isFallback = currentUrl.searchParams.get(fallbackParam) === 'true';
  if (!isFallback) {
    // On chunk loading error, reload current page with fallback param. UI server has logic to load from backup resource base.
    currentUrl.searchParams.append(fallbackParam, true);
    window.location.href = currentUrl;
  }
};

export const withChunkErrorActionGlobalErrorView = _.partial(withGlobalErrorView, _, _, _, fallbackOnChunkError);
